import React from "react";
import {Manager, Popper, Reference} from "react-popper";
import {useToggle} from "react-use";
import {Button, styled} from "@reside/ui";
import {connect} from "react-redux";
import {select} from "../../../../store/store";

type DispatchProps = Readonly<{
  dismissArchiveAdmissionReminder: () => void;
}>;

type StateProps = Readonly<{
  archiveAdmissionReminderDismissed: boolean;
}>;

const ArchiveAdmissionReminderRenderer = ({
  dismissArchiveAdmissionReminder,
  archiveAdmissionReminderDismissed,
}: StateProps & DispatchProps) => {
  const [open, toggle] = useToggle(!archiveAdmissionReminderDismissed);
  return (
    <Manager>
      <div>
        <Reference>{({ref}) => <div ref={ref}></div>}</Reference>
        {open && (
          <Popper placement="bottom">
            {({ref, style}) => (
              <Wrapper ref={ref} style={style}>
                <Label>Please review and archive approved admissions.</Label>
                <Button
                  onClick={() => {
                    toggle(false);
                    dismissArchiveAdmissionReminder();
                  }}
                  testId="archiveAdmissionDismissButton"
                >
                  Ok
                </Button>
              </Wrapper>
            )}
          </Popper>
        )}
      </div>
    </Manager>
  );
};

const Wrapper = styled.div`
  margin: 0;
  padding: 8px 16px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: ${({theme}) => theme.color.white};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  z-index: 1;
`;

const Label = styled.div`
  margin-top: 5px;
  margin-bottom: 10px;
  font-weight: ${({theme}) => theme.fontWeight.bold};
  font-size: ${({theme}) => theme.fontSize[3]}px;
`;

const mapState = () =>
  select((models: any) => ({
    archiveAdmissionReminderDismissed:
      models.dashboard.archiveAdmissionReminderDismissed,
  }));

const mapDispatch = (dispatch: any): DispatchProps => {
  return {
    dismissArchiveAdmissionReminder:
      dispatch.dashboard.dismissArchiveAdmissionReminder,
  };
};

ArchiveAdmissionReminderRenderer.defaultProps = {
  archiveAdmissionReminderDismissed: false,
  dismissArchiveAdmissionReminder: () => {},
};

export const ArchiveAdmissionReminder = connect(
  mapState,
  mapDispatch,
)(ArchiveAdmissionReminderRenderer);
